import { get, post, put } from "../services/HttpService";
import { axiosIns } from "../services";
import ExportTypography from "antd/lib/typography/Typography";

export class TransferRequestApproval {
  constructor(transferRequestApprovalObject = {}) {
    this.set(transferRequestApprovalObject);
  }

  static validations = {
    id: [],
    uuid: [],
    amount: [
      {
        pattern: "^(0*[1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$",
        message: "Please enter a valid amount.",
      },
    ],
    created_at: [],
  };

  /**
   * @memberof TransferRequestApproval
   * @type API
   * @returns Promise
   */
  static list = (queryData = {}, config = {}) => {
    return get(
      `v1/internal/transfer_request_approvals/`,
      queryData,
      config
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  approve_request = (queryData = {}) => {
    return post(
      `v1/internal/transfer_request_approvals/${this.id}/update_status/`,
      queryData,
      {}
    ).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400,
    }));
  };

  static downloadApprovalReport = (queryData = {}, config = {}) => {
    return axiosIns
      .request({
        url: `v1/internal/transfer_request_approvals/download/`,
        method: "GET",
        responseType: "blob",
        params: queryData,
        headers: config,
      })
      .catch((error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400,
      }));
  };
  /**
   * @memberof TransferRequestApproval
   * @type Getter Method
   * @returns TransferRequestApproval
   */
  get = () => {
    return {
      id: this.id,
      uuid: this.uuid,
      amount: this.amount,
      status: this.status,
      created_at: this.created_at,
      approvals: this.approvals,
      approvals_required: this.approvals_required,
      override: this.override,
      approved_levels: this.approved_levels,
    };
  };

  /**
   * @memberof TransferRequestApproval
   * @type Setter Method
   * @takes TransferRequestApproval Params
   * @returns void
   */
  set = (values) => {
    Object.keys(values).forEach((x) => (this[x] = values[x]));
  };

  /**
   * @memberof TransferRequestApproval
   * @type Setter Method
   * @takes TransferRequestApproval Params
   * @returns void
   */
  reset = () => {
    this.id = undefined;
    this.uuid = undefined;
    this.amount = undefined;
    this.status = undefined;
    this.created_at = undefined;
    this.approvals = undefined;
    this.approvals_required = undefined;
    this.override = undefined;
    this.approved_levels = undefined;
  };
}
